import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { MaterialListItem } from '../../MaterialListItem/MaterialListItem';
import { getHumanSizeStr, getItemWidth } from '../../common/utils';
import { usePrefixCls } from '../../../../../config/hooks/usePrefixCls';
import { message } from '../../../../Message';
export var MaterialList = function MaterialList(props) {
  var list = props.list,
    isLoading = props.isLoading,
    _props$uploadList = props.uploadList,
    uploadList = _props$uploadList === void 0 ? [] : _props$uploadList,
    _props$activeImages = props.activeImages,
    activeImages = _props$activeImages === void 0 ? [] : _props$activeImages,
    _props$pageValue = props.pageValue,
    pageValue = _props$pageValue === void 0 ? 0 : _props$pageValue,
    max = props.max,
    onPageChange = props.onPageChange,
    onActiveChange = props.onActiveChange,
    panelStyleConfig = props.panelStyleConfig,
    retryUpload = props.retryUpload;
  var cls = usePrefixCls('material-library-multiple-image-list');
  var handleScroll = function handleScroll(e) {
    var _e$currentTarget = e.currentTarget,
      scrollHeight = _e$currentTarget.scrollHeight,
      scrollTop = _e$currentTarget.scrollTop,
      clientHeight = _e$currentTarget.clientHeight;
    if (scrollHeight - scrollTop - clientHeight < 100) {
      onPageChange(pageValue + 1);
    }
  };
  if (!isLoading && list.length === 0) {
    return React.createElement(React.Fragment, null, "\u7D20\u6750\u5E93\u7A7A\u7A7A\u5982\u4E5F~");
  }
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: "".concat(cls, "-imgs"),
    onScroll: handleScroll
  }, uploadList.map(function (item, index) {
    return React.createElement(MaterialListItem, {
      onClick: function onClick() {},
      retry: function retry() {
        return retryUpload(item);
      },
      key: index,
      id: "".concat(item.name, "_").concat(index.toString()),
      style: {
        width: getItemWidth(panelStyleConfig)
      },
      isActive: false,
      url: item.url,
      name: item.name,
      desc: "".concat(item.width, " x ").concat(item.height, "  ").concat(getHumanSizeStr(item.size)),
      isUploading: item.isUploading,
      errorMessage: item.errorMessage
    });
  }), list.map(function (item) {
    return React.createElement(MaterialListItem, {
      activeColor: '#22DE51',
      onClick: function onClick(id) {
        var isExisted = activeImages.find(function (i) {
          return i.materialId === id;
        });
        if (isExisted) {
          return onActiveChange(activeImages.filter(function (i) {
            return i.materialId !== id;
          }));
        }
        if (max === activeImages.length) {
          message.warning("\u6700\u591A\u53EA\u80FD\u9009\u62E9".concat(max, "\u5F20\u56FE\u7247"));
          return;
        }
        var newImage = list.find(function (i) {
          return i.materialId === id;
        });
        if (newImage) {
          activeImages.push(newImage);
          onActiveChange(_toConsumableArray(activeImages));
        }
      },
      key: item.materialId,
      id: item.materialId,
      style: {
        width: getItemWidth(panelStyleConfig)
      },
      isActive: !!activeImages.find(function (i) {
        return i.materialId === item.materialId;
      }),
      url: item.imageUrl,
      name: item.description,
      desc: "".concat(item.imageWidth, " x ").concat(item.imageHeight, "  ").concat(getHumanSizeStr(item.imageSize))
    });
  })));
};